import { styled } from '@mui/material/styles';

export const LangSelector = styled('div')(({ theme, selected }) => ({
  alignItems: 'center',
  background: selected ? theme.color.background.default : theme.color.background.surface,
  boxSizing: 'border-box',
  ...(selected && {
    color: theme.color.primary.main
  }),
  cursor: 'pointer',
  display: 'flex',
  padding: '0.5em 1em',
  textTransform: 'uppercase'
}));

export const SelectorContainer = styled('div')(() => ({
  alignSelf: 'stretch',
  display: 'flex',
  flexShrink: 0,
  overflow: 'hidden'
}));
